export default {
    navigationBarTitleText: "发布动态",
  };
  